import React from "react";
import { Grid } from "@material-ui/core";
import * as Icons from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

export default function PreventEntry() {
  const { t } = useTranslation();
  return (
    <Grid container alignContent="center" justifyContent="center" style={{'height':'60vh'}}>
        <div className="d-flex flex-column justify-content-center align-items-center" style={{'color':'#d6d6d6'}}>
        <Icons.DashCircleFill size={70} className="mb-3" style={{'color':'#e2bebb'}}/>
        <p className="h5 mb-3">
            {t('factorPreventEntry_1')}
        </p>
        <strong>
            {t('factorPreventEntry_2')}
        </strong>
        </div>
    </Grid>
  );
};